<template>
  <div
    class="BoxParte mb-4"
    :class="{'BoxParte_error': propErrorsCarga && propUniqueParte}">
    <div class="BoxParte_header p-2">
      <h3 class="BoxParte_header_title">
        {{ parte.pessoa.nome }}
      </h3>
    </div>

    <div class="BoxParte_body px-3 py-2">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col-10 d-inline-flex BoxParte_body_content">
          <div class="d-inline-block col-2">
            <ul class="BoxParte_list">
              <li class="BoxParte_list_item BoxParte_list_title">
                Profissão
              </li>

              <li class="BoxParte_list_item">
                <strong>{{ parte.pessoa.ocupacao_declarada || 'Não Cadastrado' }}</strong>
              </li>
            </ul>
          </div>

          <div class="d-inline-block col-2">
            <ul class="BoxParte_list">
              <li class="BoxParte_list_item BoxParte_list_title">
                Nacionalidade
              </li>

              <li class="BoxParte_list_item">
                <strong>{{ parte.pessoa.nacionalidade ? parte.pessoa.nacionalidade.nome : 'Não informado' }}</strong>
              </li>
            </ul>
          </div>


          <div class="d-inline-block col-2">
            <ul class="BoxParte_list">
              <li class="BoxParte_list_item BoxParte_list_title">
                Estado Civil
              </li>

              <li class="BoxParte_list_item">
                <strong>{{ parte.pessoa.estado_civil || 'Não Cadastrado' }}</strong>
              </li>
            </ul>
          </div>

          <div class="d-inline-block col-3">
            <ul class="BoxParte_list">
              <li class="BoxParte_list_item BoxParte_list_title">
                Endereço Cadastrado
              </li>

              <li class="BoxParte_list_item">
                <strong>{{ verifyAddress() ? `Sim` : 'Nâo' }}</strong>
              </li>
            </ul>
          </div>

          <div class="d-inline-block col-3">
            <ul class="BoxParte_list">
              <li class="BoxParte_list_item BoxParte_list_title">
                {{ propTipo == 'CASAMENTO' ? 'Tipo' : 'Declarante ou Testemunha' }}
              </li>

              <li class="BoxParte_list_item">
                <strong> {{ parte.tipo ? parte.tipo.replace(/\_/g, " ").toLowerCase() : 'Testemunha' }}</strong>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-2">
          <div v-if="!noEditButton"
               class="row no-gutters justify-content-end align-items-center">
            <div class="d-inline-block">
              <button
                type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="$emit('remove', parte)">
                Remover
              </button>

              <button
                class="btn btn-sm btn-primary"
                type="button"
                @click="$emit('edit', parte)">
                Editar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BoxPartes',
    props: {
      parte: { type: Object, default: ()=>{} },
      noEditButton: Boolean,
      propTipo: {type: String, default: ()=> ''},
      propUniqueParte: { type: Boolean, default: false},
      propErrorsCarga: {type: Boolean, default: false}
    },
    methods: {
      verifyAddress () {
        if (this.parte.pessoa.endereco) {
          const {logradouro, cidade, uf} = this.parte.pessoa.endereco

          if (logradouro || cidade || uf) return true

          return false
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .BoxParte {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_error {
      border: solid 2px #8B0000;
    }

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
        font-weight: 500;

      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {
        strong {
          text-transform: capitalize;
        }
      }

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }
</style>
